module.exports = __webpack_public_path__ + "img/1575028909.094290a4.jpg";